export const API_ENDPOINTS = {
  LOGIN: "auth/login",
  REGISTERUSERS: "users",
  EXERCISES: "exercises",
  WORKOUTS: "workouts",
  WORKOUTS_EXERCISES: "workout-exercises",
  CHALLENGES: "challenges",
  S3: "s3",
  COURSES: "courses",
  USER_COURSE: "user-courses/all-user-courses",
  COURSES_CLASS: "classes",
  USER_WORKOUTS: "user-workouts/get-all-user-workouts",
  USER_CHALLENGES: "user-challenges/get-all-user-challenges",
  NOTIFACTION: "notifications",
  READ_NOTIFACTION: "notifications/read-notification",
  DASHBOARD: "dashboard/Admin",
  MEAL: "/diet-plans",
  GET_ALL_REWARDS:"user-challenges/get-all-user-challenges",
  Badges:"rewards"
};
